exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select.selected[data-v-fdf75e62]{color:#000}.dropdown-container[data-v-fdf75e62]{background-color:#efefef;padding:20px;width:100%;margin-top:30px;position:relative}.dropdown-container[data-v-fdf75e62]:before{content:\"\";position:absolute;top:-15px;left:25%;-webkit-transform:translateX(-50%);transform:translateX(-50%);border-width:0 20px 20px;border-style:solid;border-color:transparent transparent #efefef}.dropdown-container .form-group[data-v-fdf75e62]{margin-bottom:20px}.mb-35[data-v-fdf75e62]{margin-bottom:35px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fdf75e62","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/app/components/SelectClassicDropdown.vue
// module id = VwSa
// module chunks = 1